export default __webpack_public_path__ + "static/media/LogoEscudoVermelho.bc97026b.svg";